export default __webpack_public_path__ + "static/media/client-5.d387f5c3.png";